import React, { useEffect, useState } from 'react';
import { Card, Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  MaturityScheduleResponse,
  MaturityScheduleWithTransactionInfo,
} from '../model/MaturitySchedule.model';
import MaturityScheduleService from '../service/maturity-schedule-service/MaturitySchedule.service';
import CreatedTodayHeader from '../component/maturity-created-today/CreatedTodayHeader';
import CreatedTodayStatistics from '../component/maturity-created-today/CreatedTodayStatistics';
import CreatedTodayTable from '../component/maturity-created-today/CreatedTodayTable';
import { useCardDetail } from '../context/CardDetailContext';

// Convert DTO to MaturityScheduleResponse
const convertToMaturityScheduleResponse = (
  dto: any
): MaturityScheduleResponse => {
  return {
    id: dto.id,
    createdAt: dto.createdAt || dto.updatedAt || '',
    updatedAt: dto.updatedAt || '',
    deletedAt: dto.deletedAt || null,
    dueDate: dto.dueDate,
    repaymentAmount: dto.repaymentAmount,
    status: dto.status,
    feeApplied: dto.feeApplied,
    creditCard: dto.creditCard,
    transactions: dto.transactions || [],
    employees: dto.employees || [],
    notes: dto.notes || '',
    isChecked: false,
    commissionRateForPartner: dto.commissionRateForPartner || 0,
    createdBy: dto.createdBy,
    createdByName: dto.createdByName,
    totalDepositAmount: dto.totalDepositAmount,
    totalWithdrawalAmount: dto.totalWithdrawalAmount,
    remainingAmount: dto.remainingAmount,
    balanceDifference: dto.balanceDifference,
    totalPaymentAmount: dto.totalPaymentAmount,
  };
};

const MaturityCreatedToday: React.FC = () => {
  const [data, setData] = useState<MaturityScheduleResponse[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setSelectedCard, setMaturityScheduleId, setMaturityYear } =
    useCardDetail();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: any = await MaturityScheduleService.getCreatedToday();
      const arr: any[] = res?.data ?? res ?? [];
      const converted = arr.map(convertToMaturityScheduleResponse);
      setData(converted);
    } catch (err) {
      message.error('Lỗi khi tải dữ liệu kỳ đáo hạn tạo hôm nay');
    } finally {
      setLoading(false);
    }
  };

  const handleView = (record: MaturityScheduleResponse) => {
    // Lưu id kỳ đáo hạn vào sessionStorage
    sessionStorage.setItem(
      'maturityNavigation',
      JSON.stringify({
        maturityScheduleId: record.id,
        year: record.dueDate
          ? new Date(record.dueDate).getFullYear()
          : undefined,
      })
    );
    // Chuyển hướng sang trang card-detail
    navigate(
      `/card-detail/${record.creditCard?.id || ''}/${record.creditCard?.cardNumber || ''}`
    );
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <Card className="shadow-md">
        <CreatedTodayHeader onRefresh={fetchData} loading={loading} />
        <CreatedTodayStatistics data={data} />
        <Spin spinning={loading}>
          <CreatedTodayTable data={data} loading={loading} />
        </Spin>
      </Card>
    </div>
  );
};

export default MaturityCreatedToday;
